(() => {
  const name = 'toggleBox';

  App.components = App.components || {};

  App.components[name] = (() => {
    const toggleBoxSelector = '[data-component="toggleBox"]';
    const toggleBtnSelector = '[data-toggle-box-btn]';
    const toggleContentSelector = '[data-toggle-content]';

    const toggleContent = (e) => {
      e.preventDefault();
      e.stopPropagation();
      $(e.currentTarget)
        .toggleClass('expanded')
        .next(toggleContentSelector)
        .toggleClass('hide');
    };

    const init = ($container) => {
      if ($container.is(toggleBoxSelector)) {
        $container.on('click', toggleBtnSelector, toggleContent);
      }
    };

    return {
      init,
    };
  })();
})();
